import {gql} from '@apollo/client';
import {PodAbnormalTaskOrder} from '../types/PodAbnormalType';

export interface GetDeliveryPodAbnormalListResponse {
    getDeliveryPODAbnormalTypeListForCurrentUser: PodAbnormalTaskOrder[];
}

/**
 * POD 异常列表：直接调专用接口 getDeliveryPODAbnormalTypeListForCurrentUser
 * （与移动端 DriverViolationReviewPage 同源同接口），不再走 getDeliveryTaskOrderList 大接口。
 *
 * 换接口原因：大接口 getDeliveryTaskOrderList 后端为命令式实现，无论前端是否选
 * deliveryTaskOrderList 字段，都会强制计算司机全量任务列表 + 路径规划 + 排序（PC 端根本不需要）。
 * 专用接口只算 POD 异常那部分，去掉这块无谓开销。
 *
 * - DSP 经理登录 → 后端从 token 取 dspId，返回本 DSP 全部 POD 异常订单（近 15 天；状态 3/5）。无入参，无越权风险。
 * - 字段相比 app 端裁剪 + 补选：保留 podImageS3UrlsJson（详情抽屉展示）、podImageS3KeysJson
 *   （重传回显 objectKey），仅取 PC 端列表 + 详情消费到的字段。
 */
export const GET_DELIVERY_POD_ABNORMAL_LIST = gql`
    query GetDeliveryPODAbnormalTypeListForCurrentUser {
        getDeliveryPODAbnormalTypeListForCurrentUser {
            id
                trackingNumber
                deliveredDriverAccountName
                podUpdateTimeString
                isAllowUpdatePod
                orderWithAddress {
                    order {
                        id
                        trackingNumber
                        deliveredAt
                        preDeliveredAt
                        podReviewStatus
                        podImageS3KeysJson
                        podImageS3UrlsJson
                        podReviewMessage {
                            id
                            failureOtherReason
                            lang
                            translateFailureOtherReason {
                                lang
                                translateFailureOtherReason
                            }
                        }
                        podReviewReasons {
                            l1Code
                            l1Label {
                                zh
                                en
                                es
                            }
                            driverNotification {
                                zh
                                en
                                es
                            }
                            l2Reasons {
                                l2Code
                                l2Label {
                                    zh
                                    en
                                    es
                                }
                                isLegacy
                            }
                        }
                    }
                }
            }
        }
`;
